const header = document.querySelector('.main-header');
const toggleOffset = 75;
const toggleClass = 'sticky';

if (header) {
    window.addEventListener('scroll', () => {
        const currentScroll = window.scrollY;
        if (currentScroll > toggleOffset) {
            header.classList.add(toggleClass);
        } else {
            header.classList.remove(toggleClass);
        }
    });

    if (window.scrollY > toggleOffset) {
        header.classList.add(toggleClass);
    } else {
        header.classList.remove(toggleClass);
    }
}
